// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --sk_nav: #00558a;
    --sk_nav_hover: #591b56;
    --sk_nav_selected: #00558a;
    --sk_inactive: #cccccc;
    --sk_active: #112299;
    --sk_selected: #ffff00;
    --sk_icon: #5ea3c0;
    --sk_emphase: #504747;
    --sk_text: #000000;
    --sk_text_inverse: #ffffff;
    --sk_background: #f7fbfd;
    --sk_oddLine: #f0f0f0;
    --sk_evenLine: transparent;
}

/* 00558a   */
.actionLink {
    cursor: pointer;
}

.button,
.button:hover {
    background-color: var(--sk_active);
    color: var(--sk_text_inverse);
}

.link,
.link:hover {
    font-style: italic;
    text-decoration: underline !important;
}

.hideBeforeHover {
    display: none;
}

.showOnHover:hover:not(.whileAssetFolderLink) .hideBeforeHover {
    display: inline;
}

.selected {
    background-color: var(--sk_selected);
}

.hidden {
    display:none !important;
}

.wrapper {
    display: flex;
    align-items: stretch;
}

.fullSize {
    max-width: 100%;
}

.fullHeight {
    height: 90vh !important;
}

#page {
    width: 100%;
    min-height: 100vh;
}


#content {
    margin-top:10px;
    padding: 20px;
    width: 100%;
}

.popover {
    max-width: 50%;
}

.navigator {
    height:100%;
}

.assetUploader {
    position: absolute;
    bottom: 0px;
    width: 100%;
}

.asset {
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.uploadComponent {
    outline: 2px dashed rgb(255, 158, 23);
    outline-offset: -10px;
    transition: outline-offset .15s ease-in-out, background-color .4s linear;
    font-size: 1.25rem;
    background-color: white;
    position: relative;
    width: 100%;
    font-family: OpenSans;
    font-weight: 300;
    color: var(--main-link-color);
}

.uploadComponent:hover {
    background-color: rgba(255, 158, 23, 0.5);
}

.uploadComponent strong {
    color: #000;
}

.uploadComponent input[type="file"] {
    width: 0.1px;
    height: 0.1px;
}

.uploadComponent label {
    width: 100%;
    cursor: pointer;
    padding-top: 20px;
    padding-bottom: 10px;
}

.card-body.container.fullSize {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100vh - 150px);
}

@media (max-width: 992px) {
    .desktop-only {
        display:none !important;
    }
}

:root {
    --ck-z-default: 1051 !important;
    --ck-z-modal: calc( var(--ck-z-default) + 999 ) !important;;
}

.modal-backdrop {
    display: none;
}

.card-header {
    background: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/sk.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;IAC1B,wBAAwB;IACxB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA,aAAa;AACb;IACI,eAAe;AACnB;;AAEA;;IAEI,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IAErB,wEAAwE;IACxE,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,0DAA0D;AAC9D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[":root {\n    --sk_nav: #00558a;\n    --sk_nav_hover: #591b56;\n    --sk_nav_selected: #00558a;\n    --sk_inactive: #cccccc;\n    --sk_active: #112299;\n    --sk_selected: #ffff00;\n    --sk_icon: #5ea3c0;\n    --sk_emphase: #504747;\n    --sk_text: #000000;\n    --sk_text_inverse: #ffffff;\n    --sk_background: #f7fbfd;\n    --sk_oddLine: #f0f0f0;\n    --sk_evenLine: transparent;\n}\n\n/* 00558a   */\n.actionLink {\n    cursor: pointer;\n}\n\n.button,\n.button:hover {\n    background-color: var(--sk_active);\n    color: var(--sk_text_inverse);\n}\n\n.link,\n.link:hover {\n    font-style: italic;\n    text-decoration: underline !important;\n}\n\n.hideBeforeHover {\n    display: none;\n}\n\n.showOnHover:hover:not(.whileAssetFolderLink) .hideBeforeHover {\n    display: inline;\n}\n\n.selected {\n    background-color: var(--sk_selected);\n}\n\n.hidden {\n    display:none !important;\n}\n\n.wrapper {\n    display: flex;\n    align-items: stretch;\n}\n\n.fullSize {\n    max-width: 100%;\n}\n\n.fullHeight {\n    height: 90vh !important;\n}\n\n#page {\n    width: 100%;\n    min-height: 100vh;\n}\n\n\n#content {\n    margin-top:10px;\n    padding: 20px;\n    width: 100%;\n}\n\n.popover {\n    max-width: 50%;\n}\n\n.navigator {\n    height:100%;\n}\n\n.assetUploader {\n    position: absolute;\n    bottom: 0px;\n    width: 100%;\n}\n\n.asset {\n    background-size: contain;\n    background-position: center center;\n    background-repeat: no-repeat;\n}\n\n.ellipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.uploadComponent {\n    outline: 2px dashed rgb(255, 158, 23);\n    outline-offset: -10px;\n    -webkit-transition: outline-offset .15s ease-in-out, background-color .4s linear;\n    transition: outline-offset .15s ease-in-out, background-color .4s linear;\n    font-size: 1.25rem;\n    background-color: white;\n    position: relative;\n    width: 100%;\n    font-family: OpenSans;\n    font-weight: 300;\n    color: var(--main-link-color);\n}\n\n.uploadComponent:hover {\n    background-color: rgba(255, 158, 23, 0.5);\n}\n\n.uploadComponent strong {\n    color: #000;\n}\n\n.uploadComponent input[type=\"file\"] {\n    width: 0.1px;\n    height: 0.1px;\n}\n\n.uploadComponent label {\n    width: 100%;\n    cursor: pointer;\n    padding-top: 20px;\n    padding-bottom: 10px;\n}\n\n.card-body.container.fullSize {\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: calc(100vh - 150px);\n}\n\n@media (max-width: 992px) {\n    .desktop-only {\n        display:none !important;\n    }\n}\n\n:root {\n    --ck-z-default: 1051 !important;\n    --ck-z-modal: calc( var(--ck-z-default) + 999 ) !important;;\n}\n\n.modal-backdrop {\n    display: none;\n}\n\n.card-header {\n    background: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
